<script setup>
import { Dialog as HeadlessDialog, TransitionRoot } from "@headlessui/vue";

defineOptions({ inheritAttrs: false });

defineProps(["show", "initialFocus"]);
</script>

<template>
  <TransitionRoot as="template" :show="show">
    <HeadlessDialog as="div" class="relative z-50" :open="show" :initial-focus="initialFocus" v-bind="$attrs">
      <slot />
    </HeadlessDialog>
  </TransitionRoot>
</template>
